"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnToggleSearchWrapper = exports.TableOptionsWrapper = exports.StyledTable = exports.TableWrapper = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const styles_1 = require("../../styles");
exports.TableWrapper = (0, styled_1.default)('div') `
  display: ${({ inline }) => (inline ? 'inline-flex' : 'flex')};
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
`;
exports.StyledTable = (0, styled_1.default)('table') `
  ${styles_1.baseStyle}
  * {
    box-sizing: border-box;
  }
  border-bottom: ${styles_1.borderStyle};
  border-left: ${styles_1.borderStyle};
  border-right: ${styles_1.borderStyle};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  -webkit-font-smoothing: antialiased;
  min-width: 100%;
  width: ${({ fixed }) => (fixed ? 'auto' : '100%')};
  table-layout: ${({ fixed }) => (fixed ? 'fixed' : 'auto')};
`;
exports.TableOptionsWrapper = (0, styled_1.default)('div') `
  ${styles_1.baseStyle}
  ${styles_1.stickyStyle}
  top: ${(props) => `${props.filterTop}px`};
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  width: ${(props) => props.width
    ? `calc(${props.width}px + ${(0, ui_theme_1.fromTheme)('border_width')(props)} + ${(0, ui_theme_1.fromTheme)('border_width')(props)})`
    : '100%'};
  padding: 0;
  z-index: 3;
  & > * {
    flex: 1 1 100%;
  }
`;
exports.ColumnToggleSearchWrapper = (0, styled_1.default)('div') `
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
  align-items: flex-end;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  & > *:not(:last-of-type) {
    margin-right: 0.5em;
  }
`;
//# sourceMappingURL=Table.styles.js.map